// Policyholder Resource Center — educational authority, not blog/marketing.
export const INSIGHTS = [
  {
    slug: "what-public-adjuster-does",
    category: "Foundations",
    title: "What a Public Adjuster Actually Does",
    excerpt: "The role, the authority, and the boundaries of public adjusting as practiced under Florida law.",
    read_time: "6 min",
  },
  {
    slug: "denial-letter-anatomy",
    category: "Claim Recovery",
    title: "Reading the Anatomy of a Denial Letter",
    excerpt: "How to decode carrier language, identify the actual basis for denial, and prepare a re-presentation file.",
    read_time: "9 min",
  },
  {
    slug: "florida-hurricane-deductibles",
    category: "Florida Statutes",
    title: "Florida Hurricane Deductibles, Explained",
    excerpt: "Calendar-year deductibles, named-storm thresholds, and the math that determines what a policyholder owes.",
    read_time: "7 min",
  },
  {
    slug: "documenting-roof-damage",
    category: "Documentation",
    title: "Documenting Roof Damage Before the Adjuster Arrives",
    excerpt: "Photographic protocols, sample collection, and the evidentiary record that determines claim outcomes.",
    read_time: "8 min",
  },
];
